import { token } from '@bynder/design-system';
import {
  IconSound,
  IconCollection,
  IconBrandGuidelines,
  IconFont,
  IconVideo,
  IconImage,
  IconManualFocus,
  IconFigma,
  IconVimeo,
  IconTextStyle,
  IconSpreadsheet,
} from '@bynder/icons';
import { IconButton, IconCleanCard, IconYoutube } from '@bynder/icons';
import { WIDGET_TYPE } from '../../types';

export const getWidgetIcon = (widgetType: WIDGET_TYPE) => {
  switch (widgetType) {
    case WIDGET_TYPE.BUTTON:
      return <IconButton />;
    case WIDGET_TYPE.AUDIO:
      return <IconSound style={{ color: token.gray600 }} />;
    case WIDGET_TYPE.COLLECTION:
      return <IconCollection style={{ color: token.gray600 }} />;
    case WIDGET_TYPE.COLOR_PALETTE:
      return <IconBrandGuidelines style={{ color: token.gray600 }} />;
    case WIDGET_TYPE.IMAGE:
      return <IconImage style={{ color: token.gray600 }} />;
    case WIDGET_TYPE.SPACER:
      return <IconManualFocus style={{ color: token.gray600 }} />;
    case WIDGET_TYPE.TABLE:
      return <IconSpreadsheet />;
    case WIDGET_TYPE.TEXT:
    case WIDGET_TYPE.TITLE:
      return <IconFont />;
    case WIDGET_TYPE.TEA:
    return <IconTextStyle />;
    case WIDGET_TYPE.VIDEO:
      return <IconVideo style={{ color: token.gray600 }} />;
    case WIDGET_TYPE.CARD:
      return <IconCleanCard />;
    case WIDGET_TYPE.YOUTUBE:
      return <IconYoutube />;
    case WIDGET_TYPE.VIMEO:
      return <IconVimeo />;
    case WIDGET_TYPE.FIGMA:
      return <IconFigma />;

    default:
  }
};
